module.exports = __webpack_public_path__ + "img/modal.2f32bb35.png";